import { getWithToken, postWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";
const project_template_sharing = apiUrl + "/project_template_sharing";
const routes = {
  label: "Project Template Sharing",
  root: project_template_sharing,
  get_by_company_id: project_template_sharing + "/get_by_company_id",
  new: project_template_sharing + "/new",
  delete: project_template_sharing + "/delete",
};
export const ProjectTemplateSharing = {
  label: routes.label,
  get_by_company_id: (company_id) => getWithToken(routes.get_by_company_id, { company_id }),
  /**
   * @param {[{company_id: number, project_id: string}]} project_template_sharings
   * @returns
   */
  new: (project_template_sharings) => postWithToken(routes.new, project_template_sharings),
  /**
   * @param {[{company_id: number, project_id: string}]} project_template_sharings
   * @returns
   */
  delete: (project_template_sharings) => postWithToken(routes.delete, project_template_sharings),
};
